var $, _;
if (typeof module === 'object' && module.exports) {
	var fetch = require('cross-fetch');
	var _ = require('underscore');
}

var Client = function Client(alternateHost, alternateProtocol) {
	var self = this;
	self.sharedHeaders = {};
	self.responseHandlers = [];

	self.alternateHost = alternateHost;
	self.alternateProtocol = alternateProtocol;
	self.errorHandler = function(error) {
		// Placeholder
		return Promise.reject(error)
	}

	function getUrlBase() {
		var protocol = self.alternateProtocol || "https";
		var host = self.alternateHost || "matilda.whooosreading.org";
		return protocol + "://" + host;
	}

	// Adds an Authorization header to send along with any
	//   requests through using this instance of the client
	self.addAuth = function(value) {
		self.sharedHeaders["Authorization"] = value;
	}
	self.removeAuth = function() {
		delete self.sharedHeaders["Authorization"];
	}
	self.addResponseHandler = function(handler) {
		self.responseHandlers.push(handler);
	}
	self.resetResponseHandlers = function(value) {
		self.responseHandlers = [];
	}
	self.setErrorHandler = function(handler) {
		self.errorHandler = handler;
	}

	// api.postBooks((primary_parameters), (additional_parameters))

//   primary_parameters added to query for GET or DELETE and body for POST and PATCH\n
//   optional additional_parameters: { query: {}, body: {}, headers: {}, form: {} }
//   returns: promise of json data

self.postBooks = function() {
	var data = null;
	var queryParams = {};
	var headerParams =  { "content-type": "application/json" };
	// var postBinaryBody = null;

	var url = getUrlBase() + "/api/v1/books";
	// url += ".json";

	url = url;

	var primaryParamsIndex = 0;
	var primaryParamsAsData = false;

	if (primaryParamsAsData) {
		_.extend(queryParams, arguments[primaryParamsIndex]);
	} else {
		data = JSON.stringify(arguments[primaryParamsIndex]);
	}

	var extraParameters = arguments[primaryParamsIndex + 1];

	if (extraParameters && extraParameters["form"] && (extraParameters["body"] || data)) {
		throw "can't submit both form and body data"
	}

	if (extraParameters != null) {
		if (extraParameters["query"]) {
			_.extend(queryParams, extraParameters["query"]);
		}

		if (extraParameters["header"]) {
			_.extend(headerParams, self.sharedHeaders, extraParameters["header"]);
		}

		if (extraParameters["body"]) {
			data = JSON.stringify(extraParameters["body"]);
		}

		if (extraParameters["form"]) {
			// Unimplemented, something to do with form data
		}

	}
	_.extend(headerParams, self.sharedHeaders);

	url += createQueryString(queryParams);

	var options = {
		method: "POST",
		body: data,
		headers: headerParams
	};

	var promise = fetch(url, options);

	_.each(self.responseHandlers, function(handler) {
		promise = promise.then(handler)
	});

	return promise.then(function(response) { return response.json(); }).catch(self.errorHandler)
}

// api.getScopedBooks(scope, (primary_parameters), (additional_parameters))

//   primary_parameters added to query for GET or DELETE and body for POST and PATCH\n
//   optional additional_parameters: { query: {}, body: {}, headers: {}, form: {} }
//   returns: promise of json data

self.getScopedBooks = function() {
	var data = null;
	var queryParams = {};
	var headerParams =  { "content-type": "application/json" };
	// var postBinaryBody = null;

	var url = getUrlBase() + "/api/v1/books/{scope}";
	// url += ".json";

	url = url.replace('{scope}', arguments[0]);

	var primaryParamsIndex = 1;
	var primaryParamsAsData = true;

	if (primaryParamsAsData) {
		_.extend(queryParams, arguments[primaryParamsIndex]);
	} else {
		data = JSON.stringify(arguments[primaryParamsIndex]);
	}

	var extraParameters = arguments[primaryParamsIndex + 1];

	if (extraParameters && extraParameters["form"] && (extraParameters["body"] || data)) {
		throw "can't submit both form and body data"
	}

	if (extraParameters != null) {
		if (extraParameters["query"]) {
			_.extend(queryParams, extraParameters["query"]);
		}

		if (extraParameters["header"]) {
			_.extend(headerParams, self.sharedHeaders, extraParameters["header"]);
		}

		if (extraParameters["body"]) {
			data = JSON.stringify(extraParameters["body"]);
		}

		if (extraParameters["form"]) {
			// Unimplemented, something to do with form data
		}

	}
	_.extend(headerParams, self.sharedHeaders);

	url += createQueryString(queryParams);

	var options = {
		method: "GET",
		body: data,
		headers: headerParams
	};

	var promise = fetch(url, options);

	_.each(self.responseHandlers, function(handler) {
		promise = promise.then(handler)
	});

	return promise.then(function(response) { return response.json(); }).catch(self.errorHandler)
}

// api.getScopedBook(scope, id, (primary_parameters), (additional_parameters))

//   primary_parameters added to query for GET or DELETE and body for POST and PATCH\n
//   optional additional_parameters: { query: {}, body: {}, headers: {}, form: {} }
//   returns: promise of json data

self.getScopedBook = function() {
	var data = null;
	var queryParams = {};
	var headerParams =  { "content-type": "application/json" };
	// var postBinaryBody = null;

	var url = getUrlBase() + "/api/v1/books/{scope}/{id}";
	// url += ".json";

	url = url.replace('{scope}', arguments[0]).replace('{id}', arguments[1]);

	var primaryParamsIndex = 2;
	var primaryParamsAsData = true;

	if (primaryParamsAsData) {
		_.extend(queryParams, arguments[primaryParamsIndex]);
	} else {
		data = JSON.stringify(arguments[primaryParamsIndex]);
	}

	var extraParameters = arguments[primaryParamsIndex + 1];

	if (extraParameters && extraParameters["form"] && (extraParameters["body"] || data)) {
		throw "can't submit both form and body data"
	}

	if (extraParameters != null) {
		if (extraParameters["query"]) {
			_.extend(queryParams, extraParameters["query"]);
		}

		if (extraParameters["header"]) {
			_.extend(headerParams, self.sharedHeaders, extraParameters["header"]);
		}

		if (extraParameters["body"]) {
			data = JSON.stringify(extraParameters["body"]);
		}

		if (extraParameters["form"]) {
			// Unimplemented, something to do with form data
		}

	}
	_.extend(headerParams, self.sharedHeaders);

	url += createQueryString(queryParams);

	var options = {
		method: "GET",
		body: data,
		headers: headerParams
	};

	var promise = fetch(url, options);

	_.each(self.responseHandlers, function(handler) {
		promise = promise.then(handler)
	});

	return promise.then(function(response) { return response.json(); }).catch(self.errorHandler)
}

// api.patchScopedBook(scope, id, (primary_parameters), (additional_parameters))

//   primary_parameters added to query for GET or DELETE and body for POST and PATCH\n
//   optional additional_parameters: { query: {}, body: {}, headers: {}, form: {} }
//   returns: promise of json data

self.patchScopedBook = function() {
	var data = null;
	var queryParams = {};
	var headerParams =  { "content-type": "application/json" };
	// var postBinaryBody = null;

	var url = getUrlBase() + "/api/v1/books/{scope}/{id}";
	// url += ".json";

	url = url.replace('{scope}', arguments[0]).replace('{id}', arguments[1]);

	var primaryParamsIndex = 2;
	var primaryParamsAsData = false;

	if (primaryParamsAsData) {
		_.extend(queryParams, arguments[primaryParamsIndex]);
	} else {
		data = JSON.stringify(arguments[primaryParamsIndex]);
	}

	var extraParameters = arguments[primaryParamsIndex + 1];

	if (extraParameters && extraParameters["form"] && (extraParameters["body"] || data)) {
		throw "can't submit both form and body data"
	}

	if (extraParameters != null) {
		if (extraParameters["query"]) {
			_.extend(queryParams, extraParameters["query"]);
		}

		if (extraParameters["header"]) {
			_.extend(headerParams, self.sharedHeaders, extraParameters["header"]);
		}

		if (extraParameters["body"]) {
			data = JSON.stringify(extraParameters["body"]);
		}

		if (extraParameters["form"]) {
			// Unimplemented, something to do with form data
		}

	}
	_.extend(headerParams, self.sharedHeaders);

	url += createQueryString(queryParams);

	var options = {
		method: "PATCH",
		body: data,
		headers: headerParams
	};

	var promise = fetch(url, options);

	_.each(self.responseHandlers, function(handler) {
		promise = promise.then(handler)
	});

	return promise.then(function(response) { return response.json(); }).catch(self.errorHandler)
}

// api.getLibraryOnline((primary_parameters), (additional_parameters))

//   primary_parameters added to query for GET or DELETE and body for POST and PATCH\n
//   optional additional_parameters: { query: {}, body: {}, headers: {}, form: {} }
//   returns: promise of json data

self.getLibraryOnline = function() {
	var data = null;
	var queryParams = {};
	var headerParams =  { "content-type": "application/json" };
	// var postBinaryBody = null;

	var url = getUrlBase() + "/api/v1/library/online";
	// url += ".json";

	url = url;

	var primaryParamsIndex = 0;
	var primaryParamsAsData = true;

	if (primaryParamsAsData) {
		_.extend(queryParams, arguments[primaryParamsIndex]);
	} else {
		data = JSON.stringify(arguments[primaryParamsIndex]);
	}

	var extraParameters = arguments[primaryParamsIndex + 1];

	if (extraParameters && extraParameters["form"] && (extraParameters["body"] || data)) {
		throw "can't submit both form and body data"
	}

	if (extraParameters != null) {
		if (extraParameters["query"]) {
			_.extend(queryParams, extraParameters["query"]);
		}

		if (extraParameters["header"]) {
			_.extend(headerParams, self.sharedHeaders, extraParameters["header"]);
		}

		if (extraParameters["body"]) {
			data = JSON.stringify(extraParameters["body"]);
		}

		if (extraParameters["form"]) {
			// Unimplemented, something to do with form data
		}

	}
	_.extend(headerParams, self.sharedHeaders);

	url += createQueryString(queryParams);

	var options = {
		method: "GET",
		body: data,
		headers: headerParams
	};

	var promise = fetch(url, options);

	_.each(self.responseHandlers, function(handler) {
		promise = promise.then(handler)
	});

	return promise.then(function(response) { return response.json(); }).catch(self.errorHandler)
}

// api.getLibraryPlatforms((primary_parameters), (additional_parameters))

//   primary_parameters added to query for GET or DELETE and body for POST and PATCH\n
//   optional additional_parameters: { query: {}, body: {}, headers: {}, form: {} }
//   returns: promise of json data

self.getLibraryPlatforms = function() {
	var data = null;
	var queryParams = {};
	var headerParams =  { "content-type": "application/json" };
	// var postBinaryBody = null;

	var url = getUrlBase() + "/api/v1/library/platforms";
	// url += ".json";

	url = url;

	var primaryParamsIndex = 0;
	var primaryParamsAsData = true;

	if (primaryParamsAsData) {
		_.extend(queryParams, arguments[primaryParamsIndex]);
	} else {
		data = JSON.stringify(arguments[primaryParamsIndex]);
	}

	var extraParameters = arguments[primaryParamsIndex + 1];

	if (extraParameters && extraParameters["form"] && (extraParameters["body"] || data)) {
		throw "can't submit both form and body data"
	}

	if (extraParameters != null) {
		if (extraParameters["query"]) {
			_.extend(queryParams, extraParameters["query"]);
		}

		if (extraParameters["header"]) {
			_.extend(headerParams, self.sharedHeaders, extraParameters["header"]);
		}

		if (extraParameters["body"]) {
			data = JSON.stringify(extraParameters["body"]);
		}

		if (extraParameters["form"]) {
			// Unimplemented, something to do with form data
		}

	}
	_.extend(headerParams, self.sharedHeaders);

	url += createQueryString(queryParams);

	var options = {
		method: "GET",
		body: data,
		headers: headerParams
	};

	var promise = fetch(url, options);

	_.each(self.responseHandlers, function(handler) {
		promise = promise.then(handler)
	});

	return promise.then(function(response) { return response.json(); }).catch(self.errorHandler)
}

// api.getScopedLookup(scope, (primary_parameters), (additional_parameters))

//   primary_parameters added to query for GET or DELETE and body for POST and PATCH\n
//   optional additional_parameters: { query: {}, body: {}, headers: {}, form: {} }
//   returns: promise of json data

self.getScopedLookup = function() {
	var data = null;
	var queryParams = {};
	var headerParams =  { "content-type": "application/json" };
	// var postBinaryBody = null;

	var url = getUrlBase() + "/api/v1/lookup/{scope}";
	// url += ".json";

	url = url.replace('{scope}', arguments[0]);

	var primaryParamsIndex = 1;
	var primaryParamsAsData = true;

	if (primaryParamsAsData) {
		_.extend(queryParams, arguments[primaryParamsIndex]);
	} else {
		data = JSON.stringify(arguments[primaryParamsIndex]);
	}

	var extraParameters = arguments[primaryParamsIndex + 1];

	if (extraParameters && extraParameters["form"] && (extraParameters["body"] || data)) {
		throw "can't submit both form and body data"
	}

	if (extraParameters != null) {
		if (extraParameters["query"]) {
			_.extend(queryParams, extraParameters["query"]);
		}

		if (extraParameters["header"]) {
			_.extend(headerParams, self.sharedHeaders, extraParameters["header"]);
		}

		if (extraParameters["body"]) {
			data = JSON.stringify(extraParameters["body"]);
		}

		if (extraParameters["form"]) {
			// Unimplemented, something to do with form data
		}

	}
	_.extend(headerParams, self.sharedHeaders);

	url += createQueryString(queryParams);

	var options = {
		method: "GET",
		body: data,
		headers: headerParams
	};

	var promise = fetch(url, options);

	_.each(self.responseHandlers, function(handler) {
		promise = promise.then(handler)
	});

	return promise.then(function(response) { return response.json(); }).catch(self.errorHandler)
}

// api.postScopedLookup(scope, (primary_parameters), (additional_parameters))

//   primary_parameters added to query for GET or DELETE and body for POST and PATCH\n
//   optional additional_parameters: { query: {}, body: {}, headers: {}, form: {} }
//   returns: promise of json data

self.postScopedLookup = function() {
	var data = null;
	var queryParams = {};
	var headerParams =  { "content-type": "application/json" };
	// var postBinaryBody = null;

	var url = getUrlBase() + "/api/v1/lookup/{scope}";
	// url += ".json";

	url = url.replace('{scope}', arguments[0]);

	var primaryParamsIndex = 1;
	var primaryParamsAsData = false;

	if (primaryParamsAsData) {
		_.extend(queryParams, arguments[primaryParamsIndex]);
	} else {
		data = JSON.stringify(arguments[primaryParamsIndex]);
	}

	var extraParameters = arguments[primaryParamsIndex + 1];

	if (extraParameters && extraParameters["form"] && (extraParameters["body"] || data)) {
		throw "can't submit both form and body data"
	}

	if (extraParameters != null) {
		if (extraParameters["query"]) {
			_.extend(queryParams, extraParameters["query"]);
		}

		if (extraParameters["header"]) {
			_.extend(headerParams, self.sharedHeaders, extraParameters["header"]);
		}

		if (extraParameters["body"]) {
			data = JSON.stringify(extraParameters["body"]);
		}

		if (extraParameters["form"]) {
			// Unimplemented, something to do with form data
		}

	}
	_.extend(headerParams, self.sharedHeaders);

	url += createQueryString(queryParams);

	var options = {
		method: "POST",
		body: data,
		headers: headerParams
	};

	var promise = fetch(url, options);

	_.each(self.responseHandlers, function(handler) {
		promise = promise.then(handler)
	});

	return promise.then(function(response) { return response.json(); }).catch(self.errorHandler)
}

// api.postOverrides((primary_parameters), (additional_parameters))

//   primary_parameters added to query for GET or DELETE and body for POST and PATCH\n
//   optional additional_parameters: { query: {}, body: {}, headers: {}, form: {} }
//   returns: promise of json data

self.postOverrides = function() {
	var data = null;
	var queryParams = {};
	var headerParams =  { "content-type": "application/json" };
	// var postBinaryBody = null;

	var url = getUrlBase() + "/api/v1/overrides";
	// url += ".json";

	url = url;

	var primaryParamsIndex = 0;
	var primaryParamsAsData = false;

	if (primaryParamsAsData) {
		_.extend(queryParams, arguments[primaryParamsIndex]);
	} else {
		data = JSON.stringify(arguments[primaryParamsIndex]);
	}

	var extraParameters = arguments[primaryParamsIndex + 1];

	if (extraParameters && extraParameters["form"] && (extraParameters["body"] || data)) {
		throw "can't submit both form and body data"
	}

	if (extraParameters != null) {
		if (extraParameters["query"]) {
			_.extend(queryParams, extraParameters["query"]);
		}

		if (extraParameters["header"]) {
			_.extend(headerParams, self.sharedHeaders, extraParameters["header"]);
		}

		if (extraParameters["body"]) {
			data = JSON.stringify(extraParameters["body"]);
		}

		if (extraParameters["form"]) {
			// Unimplemented, something to do with form data
		}

	}
	_.extend(headerParams, self.sharedHeaders);

	url += createQueryString(queryParams);

	var options = {
		method: "POST",
		body: data,
		headers: headerParams
	};

	var promise = fetch(url, options);

	_.each(self.responseHandlers, function(handler) {
		promise = promise.then(handler)
	});

	return promise.then(function(response) { return response.json(); }).catch(self.errorHandler)
}

// api.getSearch((primary_parameters), (additional_parameters))

//   primary_parameters added to query for GET or DELETE and body for POST and PATCH\n
//   optional additional_parameters: { query: {}, body: {}, headers: {}, form: {} }
//   returns: promise of json data

self.getSearch = function() {
	var data = null;
	var queryParams = {};
	var headerParams =  { "content-type": "application/json" };
	// var postBinaryBody = null;

	var url = getUrlBase() + "/api/v1/search";
	// url += ".json";

	url = url;

	var primaryParamsIndex = 0;
	var primaryParamsAsData = true;

	if (primaryParamsAsData) {
		_.extend(queryParams, arguments[primaryParamsIndex]);
	} else {
		data = JSON.stringify(arguments[primaryParamsIndex]);
	}

	var extraParameters = arguments[primaryParamsIndex + 1];

	if (extraParameters && extraParameters["form"] && (extraParameters["body"] || data)) {
		throw "can't submit both form and body data"
	}

	if (extraParameters != null) {
		if (extraParameters["query"]) {
			_.extend(queryParams, extraParameters["query"]);
		}

		if (extraParameters["header"]) {
			_.extend(headerParams, self.sharedHeaders, extraParameters["header"]);
		}

		if (extraParameters["body"]) {
			data = JSON.stringify(extraParameters["body"]);
		}

		if (extraParameters["form"]) {
			// Unimplemented, something to do with form data
		}

	}
	_.extend(headerParams, self.sharedHeaders);

	url += createQueryString(queryParams);

	var options = {
		method: "GET",
		body: data,
		headers: headerParams
	};

	var promise = fetch(url, options);

	_.each(self.responseHandlers, function(handler) {
		promise = promise.then(handler)
	});

	return promise.then(function(response) { return response.json(); }).catch(self.errorHandler)
}

}

function createQueryString(queryParams) {
	var queryString ='';
	var i = 0;
	for (var queryParamName in queryParams) {
		if (i == 0) {
			queryString += '?' ;
		} else {
			queryString += '&' ;
		}
		
		queryString += queryParamName + '=' + encodeURIComponent(queryParams[queryParamName]);
		i++;
	}
	
	return queryString;
}

// export module for Node.js
if (typeof module === 'object' && module.exports) {
	module.exports = Client;
}



// WEBPACK FOOTER //
// ./modules/wr_apis/apis/matilda_api/node_package/src/client.js